export default __webpack_public_path__ + "static/media/moonstar.d026f57c.jpg";